import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import VueFinalModal from 'vue-final-modal';
import VCalendar from 'v-calendar';
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from './quasar-user-options';
import axios from 'axios';
import SocialSharing from 'vue-social-sharing';
import VueTour from 'v3-tour';

require('v3-tour/dist/vue-tour.css');

const app = createApp(App)
  .use(router)
  .use(Quasar, quasarUserOptions)
  .use(VueFinalModal())
  .use(VCalendar, {})
  .use(SocialSharing)
  .use(VueTour);

app.config.globalProperties.axios = axios;
app.mount('#app');
export default app;
